import { useState, useEffect } from 'react';

import AccessLevelService, { verifiedRoomModerator } from 'services/AccessLevelService';


function useMarkAsSpam(accessLevel, isLoggedInUserRoomModerator) {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const isMinVerifiedRoomModerator = AccessLevelService.isMin(verifiedRoomModerator, accessLevel);
    if (isMinVerifiedRoomModerator || isLoggedInUserRoomModerator) {
      setVisible(true);
    } else {
      setVisible(false);
    }
  }, [accessLevel, isLoggedInUserRoomModerator]);

  return { visible };
}

export default useMarkAsSpam;
